module.exports = __webpack_public_path__ + "img/karriere-weiterbildung-redaktion.34b6da25.jpg";